var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b5c1aa52] .el-upload-list--picture-card .el-upload-list__item{width:120px;height:120px}[data-v-b5c1aa52] .el-upload--picture-card{width:120px;height:120px;line-height:120px;background-image:url(" + escape(require("../../../../assets/images/xiang.png")) + ");background-size:100% 100%}.upload-btn[data-v-b5c1aa52]{display:inline-block}", ""]);

// exports
